import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import { Message } from "semantic-ui-react";
import { GET_ASSIGNMENT_PTO_POLICY } from "../queries/PTOPolicy";
import { RuleDetails } from "./RuleDetails";

export const PTOPolicyDisplay = ({
  token = "",
  showPolicyNameOnly = false,
}) => {
  const { data, loading, error } = useQuery(GET_ASSIGNMENT_PTO_POLICY, {
    skip: !token,
    variables: { assignmentToken: token },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <p style={{ color: "grey" }}>Loading...</p>;
  }

  if (error) {
    return (
      <Message negative>
        <Message.Header>There was an error</Message.Header>
        <pre style={{ whiteSpace: "pre-wrap" }}>{error.toString()}</pre>
      </Message>
    );
  }

  if (!data?.assignment?.ptoPolicy) {
    return <p>No PTO policy information available.</p>;
  }

  const {
    assignment: { ptoPolicy, job },
  } = data;

  const assignmentPolicyName = ptoPolicy.name;
  const jobPolicyName = `${job.name} - ${assignmentPolicyName}`;
  const policyName = !showPolicyNameOnly ? jobPolicyName : assignmentPolicyName;

  return (
    <>
      <p>{policyName}</p>
      <p>Eligibility period: {ptoPolicy.eligibilityPeriod} days</p>
      {ptoPolicy.rules.map((rule) => (
        <RuleDetails key={rule.code} rule={rule} />
      ))}
    </>
  );
};

PTOPolicyDisplay.propTypes = {
  token: PropTypes.string,
  showPolicyNameOnly: PropTypes.bool,
};
